import { render, staticRenderFns } from "./PrecautionAudio.vue?vue&type=template&id=34790bc6&scoped=true&"
import script from "./PrecautionAudio.vue?vue&type=script&lang=ts&"
export * from "./PrecautionAudio.vue?vue&type=script&lang=ts&"
import style0 from "./PrecautionAudio.vue?vue&type=style&index=0&id=34790bc6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34790bc6",
  null
  
)

export default component.exports